(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/address.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/address.js');
"use strict";


const {
  useContext,
  Fragment
} = React;
const {
  ZipCodeInput,
  AdressInput,
  CityInput,
  ContactInput,
  CountryDropdown
} = svs.ticket_partner.sharedComponents.input;
const {
  countries
} = svs.ticket_partner.sharedComponents.input.constants;
const {
  COUNTRYID,
  CONTACT,
  ZIP,
  ADDRESS1,
  CITY
} = svs.ticket_partner.sharedComponents.input.constants.names;
const {
  UPDATE_ADDRESS
} = svs.ticket_partner.companyDetails.constants.actions;
const {
  mapHeader
} = svs.ticket_partner.companyDetails.utils;
const Address = _ref => {
  let {
    adress,
    disableOnEdit = false
  } = _ref;
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.CompanyDetailsContext);
  const {
    edit
  } = state.companyDetails;
  const {
    addressType,
    contact,
    zip,
    countryId,
    address1,
    city
  } = adress;
  const header = mapHeader(addressType.toLowerCase());
  const getCountryById = countryId => countries.find(_ref2 => {
    let {
      id
    } = _ref2;
    return countryId === id;
  }).name || '';
  const adressDetails = [contact, address1, zip, city, getCountryById(countryId)];
  const handleChange = e => {
    dispatch({
      type: UPDATE_ADDRESS,
      payload: {
        field: e.target.id,
        value: e.target.value,
        addressToUpdate: addressType
      }
    });
  };
  const handleDropdownChange = e => {
    dispatch({
      type: UPDATE_ADDRESS,
      payload: {
        field: COUNTRYID,
        value: parseInt(e.target.value, 10),
        addressToUpdate: addressType
      }
    });
  };
  return React.createElement(Fragment, null, React.createElement("h2", null, header), edit ? React.createElement(Fragment, null, React.createElement(ContactInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(CONTACT),
    state: adress,
    stateField: CONTACT
  }), React.createElement(AdressInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(ADDRESS1),
    state: adress
  }), React.createElement(ZipCodeInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(ZIP),
    state: adress
  }), React.createElement(CityInput, {
    disabled: disableOnEdit,
    handleChange: handleChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(CITY),
    state: adress
  }), React.createElement(CountryDropdown, {
    disabled: disableOnEdit,
    handleDropDownChange: handleDropdownChange,
    isLessSpace: true,
    name: "".concat(addressType, "_").concat(COUNTRYID),
    state: adress
  })) : adressDetails.map((detail, i) => React.createElement("div", {
    key: _.uniqueId(i)
  }, ' ', detail, ' ')));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.Address = Address;

 })(window);